/**
 * Relay for Collection
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const collectionNode = graphql`
  fragment collectionNode on Collection {
    id
    description
    name
    slug
    category {
      id
      name
    }
    assets{
      ...assetNode @relay(mask: false)
    }
  }
`;

export const CollectionListQuery = graphql`
  query collectionList_Query {
    viewer{
      ...collectionList_viewer
    }
  }
`;

export const CollectionPageQuery = graphql`
  query collectionPage_Query(
    $query: String,
    $filters: TrackSearchFilters,
    $license_params: [LicenseUsageParamsInput],
  ) {
    viewer{
      ...collection_viewer
    }
  }
`;

export const CollectionPageFragment = graphql`
  fragment collection_viewer on Viewer {
    ...signUpCta_viewer
    trackSearch(
      first: 100,
      offset: 0,
      query: $query,
      filters: $filters,
      license_params: $license_params,
    ) @connection(key: "collection_trackSearch") {
      edges {
        node {
          ...trackNode @relay(mask: false)
        }
      }
      total
    }
  }
`;

export const CollectionsFragment = graphql`
  fragment collectionList_viewer on Viewer {
    id
    collections(first: 1000) @connection(key: "list_collections", filters: []) {
      total
      edges{
        node{
          ...collectionNode @relay(mask: false)
          tracks{
            id
          }
        }
      }
    }
    collection_categories(first: 1000) @connection(key: "list_collection_categories", filters: []) {
      edges{
        node{
          id
          name
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/collection.ts